import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CadenciaModal.module.css';
import Button from '../../form/Button/Button';

const CadenciaModal = ({ isOpen, lastDate, lastMonth, lastYear, onConfirm, onCancel }) => {
  const [selectedCadencia, setSelectedCadencia] = useState(3);

  // Calcular a próxima data baseada na cadência selecionada
  const calculateNextDate = (cadencia) => {
    let newMonth = lastMonth + cadencia;
    let newYear = lastYear;

    while (newMonth > 12) {
      newMonth -= 12;
      newYear++;
    }

    return { month: newMonth, year: newYear };
  };

  // Mapeamento de meses em português
  const mesesNomes = [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ];

  const cadenciaOptions = [
    { value: 3, label: 'Trimestral', descricao: '3 meses' },
    { value: 6, label: 'Semestral', descricao: '6 meses' },
    { value: 12, label: 'Anual', descricao: '12 meses' }
  ];

  const handleConfirm = () => {
    onConfirm(selectedCadencia);
    setSelectedCadencia(3); // Reset para próxima vez
  };

  const handleCancel = () => {
    setSelectedCadencia(3); // Reset para próxima vez
    onCancel();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h3>Adicionar Intermediária</h3>
          <button 
            className={styles.closeBtn}
            onClick={handleCancel}
            type="button"
            aria-label="Fechar"
          >
            ×
          </button>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.lastDateInfo}>
            <p>Última intermediária: <strong>{mesesNomes[lastMonth - 1]}/{lastYear}</strong></p>
          </div>

          <div className={styles.cadenciaOptions}>
            <p className={styles.label}>Selecione o intervalo:</p>
            
            {cadenciaOptions.map((option) => {
              const next = calculateNextDate(option.value);
              const nextDateStr = `${mesesNomes[next.month - 1]}/${next.year}`;

              return (
                <div key={option.value} className={styles.optionWrapper}>
                  <label className={styles.radioLabel}>
                    <input
                      type="radio"
                      name="cadencia"
                      value={option.value}
                      checked={selectedCadencia === option.value}
                      onChange={(e) => setSelectedCadencia(Number(e.target.value))}
                      className={styles.radioInput}
                    />
                    <span className={styles.radioCustom}></span>
                    <span className={styles.optionText}>
                      <strong>{option.label}</strong>
                      <span className={styles.optionDesc}>
                        ({option.descricao}) → <strong>{nextDateStr}</strong>
                      </span>
                    </span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <Button
            variant="secondary"
            onClick={handleCancel}
            type="button"
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            type="button"
          >
            ✓ Adicionar
          </Button>
        </div>
      </div>
    </div>
  );
};

CadenciaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  lastDate: PropTypes.string,
  lastMonth: PropTypes.number.isRequired,
  lastYear: PropTypes.number.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default CadenciaModal;
